<template lang='pug'>
//- 太久未登入 需要重新登入提示區塊
div(:class='$style[`cc-popbox-relogin`]')
  div(:class='$style[`cc-content-new`]')
    div(:class='$style[`cc-content-title`]')
      span.font-bold(:class='$style[`cc-banner-main-title`]')
        span.no-wrap 已登入其他裝置

      span.font-medium(:class='$style[`cc-banner-main-subtitle`]')
        span.no-wrap(:class='$style[`small-text`]') 為了您的帳戶安全
        span.no-wrap(:class='$style[`small-text`]') ，請重新登入

    div(
      title='立即登入'
      :class='$style[`cc-content-new-confirm`]'
      @click='handleClickToRelogin')
      span 重新登入

</template>

<script>
import { mapActions, mapMutations } from 'vuex';

export default {

  // data() {
  //   return {
  //     maxNologinDays: 30,
  //   };
  // },

  mounted() {
    this.cleanAndResetJwt();
  },

  methods: {
    ...mapActions({
      userLoginMember: 'user/userLoginMember',
    }),

    ...mapMutations({
      changePopBoxStatus: 'global/POPBOX_STATUS',
      changeAuthJwtToken: 'user/USER_AUTH_JWT',
    }),

    cleanAndResetJwt() {
      this.userLoginMember({
        isLogin: false,
        djangoId: null,
        hashCode: '',
        profile: {},
      });
      this.changeAuthJwtToken(null);
      localStorage.removeItem('cc-jwt');
    },

    handleClickToRelogin() {
      this.changePopBoxStatus({
        active: true,
        include: 'login',
      });
    },
  },
};

</script>

<style module lang='scss'>
  @import '../../../sass/component/page/popbox/popRelogin.scss';
</style>
